import ConcreteStore from '../concretejs/store/';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';
import fundationPlugin from './plugins';
import NsLoaderStore from '../concretejs/store/module-nsloader';

const fundationStore = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
    strict: process.env.NODE_ENV === 'development' ? true : false, // attention en production le strict mode doit etre désactivé
    // car il est couteux en perf
};

export default class FundationStore extends ConcreteStore{
    constructor (options={}, vueInstance=null) {
        options.modules = options.modules || {};
        // options.modules.app = applicationStore;
        options.modules.fundation = fundationStore;
        options.modules.nsLoaderStore = NsLoaderStore;

        options.plugins = options.plugins || [];
        options.plugins.push(fundationPlugin);

        super(options, vueInstance);
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/store/index.js
// module id = null
// module chunks = 